import React from 'react';

const ClosingRange = ({ days, hours, minutes, seconds, fromDashboard }) => (
  <>
    <span>Closing range: </span>
    <span>{days}</span>
    <span>{hours}</span>
    {fromDashboard && <br />}
    <span>{minutes}</span>
    <span>{seconds}</span>
  </>
);

export default ClosingRange;
